<script lang="ts">
	/**
	 * Light/dark toggle.
	 *
	 * Extracted rather than inlined because the sidebar renders it at two very
	 * different sizes (full-width row vs. a bare icon in rail mode), and because
	 * the class toggle has to stay in one place — it writes to `<html>`, which
	 * the pre-hydration theme script in `AbstractID.initialize()` also reads.
	 */

	import { Button } from 'flowbite-svelte';
	import { colorTheme } from '../AbstractID';

	/** Extra classes for the icon itself (colour, size). */
	export let iconClass: string = '';

	let className: string = '';
	export { className as class };

	const fnToggleDarkMode = () => {
		$colorTheme = $colorTheme === 'dark' ? 'light' : 'dark';
		window.document.body.parentElement?.classList.toggle('dark', $colorTheme === 'dark');
	};
</script>

<Button
	class="dark:hover:bg-gray-700 {className}"
	color="alternative"
	title={$colorTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
	on:click={fnToggleDarkMode}
>
	<i class="fa-solid fa-{$colorTheme === 'dark' ? 'sun' : 'moon'} {iconClass}"></i>
</Button>
